import {removeAccessAdministrationRolePermission} from "@project/sdk/access-administration";
import {RemoveAccessAdministrationRolePermissionResponse} from "@project/sdk/access-administration/zod";
import {mutationOptions} from "@tanstack/react-query";
import {
  accessAdministrationMutationKeys,
  roleKeys,
  userAccessKeys,
} from "../../access-administration-keys";

export function removePermissionFromRoleMutationOptions(roleId: string) {
  return mutationOptions({
    mutationKey: accessAdministrationMutationKeys.removePermissionFromRole,
    mutationFn: async (permissionKey: string) =>
      RemoveAccessAdministrationRolePermissionResponse.parse(
        await removeAccessAdministrationRolePermission(roleId, permissionKey),
      ),
    onSuccess: async (_data, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: roleKeys.all}),
        client.invalidateQueries({queryKey: userAccessKeys.all}),
      ]);
    },
  });
}
